import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EvElectionOverviewComponent } from './ev-election-overview.component';
import { MatIconModule } from '@angular/material/icon';
import { SidenavigationModule } from '@shared/components/sidenavigation/sidenavigation.module';
import { ResponsiveMenuModule } from '@shared/components/responsive-menu/responsive-menu.module';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { TableModule } from '@valg-shared/components/table/table.module';
import { CdkTableModule } from '@angular/cdk/table';
import { ValgInputModule } from '@valg-shared/components/input/input.module';
import { InputDropdownModule } from '@valg-shared/components/input/input-dropdown/input-dropdown.module';
import { FormsModule } from '@angular/forms';
import { MapModule } from '@shared/components/map/map.module';
import { BarChartModule } from '@shared/components/bar-chart/bar-chart.module';
import { BarChartRendererModule } from '@shared/components/table/renderers/bar-chart-renderer/bar-chart-renderer.module';
import { ResponsiveBarChartRendererModule } from '@shared/components/table/renderers/responsive-bar-chart-renderer/responsive-bar-chart-renderer.module';
import { CardModule } from '@valg-shared/components/card/card.module';
import { BreadcrumbsModule } from '@shared/components/breadcrumbs/breadcrumbs.module';
import { ValgDKSearchModule } from '@shared/components/input/valgdk-search/valgdk-search.module';
import { TopCandidatesModule } from '@shared/components/top-candidates/top-candidates.module';
import { CountStatusModule } from '@shared/components/count-status/count-status.module';
import { PageLayoutModule } from '@shared/components/page-layout/page-layout.module';
import { ElectoralCoalitionModule } from '@shared/components/cards/electoral-coalition/electoral-coalition.module';
import { PartyVotingStatusSummaryModule } from "@shared/components/party-voting-status-summary/party-voting-status-summary.module";


@NgModule({
  declarations: [
    EvElectionOverviewComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    TableModule,
    CdkTableModule,
    ValgInputModule,
    InputDropdownModule,
    FormsModule,
    MatIconModule,
    SidenavigationModule,
    ResponsiveMenuModule,
    RouterModule,
    MapModule,
    BarChartModule,
    BarChartRendererModule,
    ResponsiveBarChartRendererModule,
    CardModule,
    BreadcrumbsModule,
    ValgDKSearchModule,
    TopCandidatesModule,
    CountStatusModule,
    PageLayoutModule,
    ElectoralCoalitionModule,
    PartyVotingStatusSummaryModule,
  ]
})
export class EvElectionOverviewModule { }
